export default __webpack_public_path__ + "static/media/BusActive.4efbe1e6.svg";